import request from '@/utils/request'

//获取用户token
export function getOpenid(query) {
  return request({
    url: '/wx/getOpenid_1_0/',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/wx-login.js